import api from '../../utils/apiFetch';

const path = 'email-templates';

export default {
  postEmailTemplate: (payload) => api.post(`${path}`, payload),
  postCustomEmailTemplate: (payload) => api.post(`${path}/customs`, payload),
  postCustomBlock: (payload) => api.post(`${path}/custom-blocks`, payload),
  getCustomBlocks: () => api.get(`${path}/custom-blocks`),
  testEmailTemplate: (payload) => api.post(`${path}/test`, payload),
  testCustomEmailTemplate: (payload) =>
    api.post(`${path}/customs/test`, payload),
  getEmailDesignOptions: () => api.get(`${path}/design-options`),
  previewEmailTemplate: (payload) => api.post(`${path}/preview`, payload),
  previewCustomEmailTemplate: (payload) =>
    api.post(`${path}/customs/preview`, payload),
  getEmailTemplates: () => api.get(`${path}`),
  getCustomEmailTemplates: () => api.get(`${path}/customs`),
  getCustomEmailVariables: () => api.get(`${path}/custom-variables`),
  checkUnsubscribedEmail: (payload) =>
    api.post(`${path}/check-unsubscribed-email`, payload),
  checkEmailBatch: (payload) => api.post(`${path}/check-email-batch`, payload),
  createEmailBatch: (payload) => api.post(`${path}/email-batch`, payload),
};
